import React, { useMemo } from "react"
import styled from "styled-components"
import Text from "@/components/common/Text"
import { getCardData } from "@/components/common/Cards"
import { useRouter } from "next/router"
import Image from "@/components/common/Image"
import dayjs from "dayjs"
import { getCssSizeValue } from "@/utils/utils"
import Icon from "@/components/common/Icon/Icon"
import { DATE_AND_TIME_FORMAT, DATE_FORMAT, ICONS } from "@/constants"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled.div`
	animation: fade-in 0.5s ease-in-out;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	row-gap: 20px;
	padding-top: 16px;
	z-index: 1;

	figure {
		height: 100%;
	}

	.description {
		//max-height: ${getCssSizeValue(150)};
		overflow-y: auto;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		row-gap: ${getCssSizeValue(40)};
		padding-top: ${getCssSizeValue(16)};
	}
`

const ContactBlock = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	align-items: start;

	.text {
		display: flex;
		width: 100%;
		align-items: center;
		column-gap: ${getCssSizeValue(16)};
	}

	.icon {
		width: ${getCssSizeValue(40)};
		aspect-ratio: 1;
		height: fit-content;
		//height: ${getCssSizeValue(40)};
	}
`

const EventCard = ({ data }) => {
	const router = useRouter()
	const { cover, header, description } = useMemo(() => getCardData(data, router.locale), [data, router.locale])
	const { address, start, end } = useMemo(() => {
		const format = data?.allDay ? DATE_FORMAT : DATE_AND_TIME_FORMAT
		const start = dayjs(data?.start).format(format)
		const end = dayjs(data?.end || data?.start).format(format)
		const address = data?.address || ""
		return {
			start,
			end,
			address,
		}
	}, [data])

	// console.log(description);

	return (
		<Wrapper>
			<Text className="typo-strawford typo-strawford-18">{header}</Text>
			{cover.url && <Image src={cover.url} focalPoint={cover.focalPoint} placeholder={cover.placeholder} alt={cover.alt} />}
			<ContactBlock>
				<Text tag="div" className="typo-borna-105">
					<Icon name={ICONS.TIME} />
					{start}
					{!data?.allDay && (
						<>
							<br />
							{end}
						</>
					)}
				</Text>
				{address && (
					<Text tag="div" className=" typo-borna-105">
						<Icon name={ICONS.PIN_MAP} />
						{address}
					</Text>
				)}
			</ContactBlock>
			{description && (
				<Text tag="div" className="description typo-strawford typo-strawford-11" dangerouslySetInnerHTML={description} />
			)}
		</Wrapper>
	)
}

export default EventCard
